import {Pipe, PipeTransform, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ApiRuleResponseDto} from '@birco/rainmesh-api';
import {RuleViewModel} from '../models/rule-view-model.interface';
import {getDisplayRuleName} from '../utils/rule-name.util';

@Pipe({
  name: 'ruleName',
  standalone: true,
  pure: false,
})
export class RuleNamePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(
    rule: Pick<ApiRuleResponseDto, 'name' | 'isSystemRule' | 'systemRuleType'> | RuleViewModel | null | undefined,
    cisternName?: string | null
  ): string {
    return getDisplayRuleName(rule, (key) => this.translateService.instant(key), cisternName);
  }
}
